<template>
  <OButton
    pure
    class="absolute z-2 transform -translate-y-1/2 u-center text-white swiper-button-custom h-9 w-9 rounded-full"
    :class="{
      'swiper-button-custom-prev left-4': direction === 'prev',
      'swiper-button-custom-next right-4': direction === 'next',
    }"
  >
    <OIcon :icon="direction === 'prev' ? 'left-white' : 'right-white'" svg-style="fill: #fff" />
  </OButton>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OButton, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: {
    OButton,
    OIcon,
  },
  props: {
    direction: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.swiper-button-custom {
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(11.25px);
  top: calc(50% - 62px);
  @include sm() {
    top: calc(50% - 84px);
  }
}
</style>
